import React from 'react'
import { Stack } from '@mui/material'

export default function SbcWrapper({ children }) {

    return (
        <Stack direction={'column'} spacing={1}>
            {children}
        </Stack>
    )
}
